const ribbonsData = [
    {
        title: 'Purple Header',
        color: 'purple',
        icon: 'mdi mdi-access-point',
        textalign: 'left',
        titlealign: 'right'
    },
    {
        title: 'Primary Header',
        color: 'primary',
        icon: 'mdi mdi-access-point',
        textalign: 'left',
        titlealign: 'right'
    },
    {
        title: 'Success Header',
        color: 'success',
        textalign: 'left',
        titlealign: 'right'
    },
    {
        title: 'Info Header',
        color: 'info',
        icon: 'mdi mdi-access-point',
        textalign: 'right',
        titlealign: 'left'
    },
    {
        title: 'Warning Header',
        color: 'warning',
        icon: 'mdi mdi-access-point',
        textalign: 'right',
        titlealign: 'left'
    },
    {
        title: 'Danger Header',
        color: 'danger',
        icon: 'mdi mdi-access-point',
        textalign: 'right',
        titlealign: 'left'
    },
    {
        title: 'Pink Header',
        color: 'pink',
        icon: 'mdi mdi-access-point',
        textalign: 'right',
        titlealign: 'left',
        shape: true
    },
    {
        title: 'Secondary Header',
        color: 'secondary',
        textalign: 'right',
        titlealign: 'left',
        shape: true
    },
    {
        title: 'Dark Header',
        color: 'dark',
        textalign: 'right',
        titlealign: 'left',
        shape: true
    },
];

export { ribbonsData };

